module.exports = "/images/fixed-contract.svg?69c0045cfa285624f6b723cff1158492";